/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { ConfigureNodesJobWizardPage } from '@/pages/ConfigureNodesJobWizard/ConfigureNodesJobWizardPage';

export function ConfigureNodesJobWizardRoute() {
  return <ConfigureNodesJobWizardPage />;
}
